'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { FaRegUser } from 'react-icons/fa';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);
  const isInicialized = useCustomerStore(s => s.isInitialized);

  const { t } = useTranslations();

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  const isAuthorited = me && me?.customer && isInicialized;

  if (isAuthorited)
    return (
      <Button variant={'outline'} asChild size={'icon'}>
        <Link prefetch={false} href={ROUTES.PROFILE()}>
          <FaRegUser size={18} />
        </Link>
      </Button>
    );

  return (
    <Button onClick={handleSignInClick} variant="outline">
      {t('text189')}
    </Button>
  );
};
